import React, { useContext, useEffect, useRef, useState } from "react";
import "./CompleteRegistration.css";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HomeIcon from "@mui/icons-material/Home";
import { useHistory } from "react-router-dom";
import theme from "../../../../utils/theme";
import RegistrationErrorModal from "../../../../components/registrationModal/RegistrationErrorModal";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import { useFormik } from "formik";
import * as Yup from "yup";
import useAuthQuery from "../../../../store/auth/useAuthQuery";
import { variableContext } from "../../../../context/VariableContex";
import Flag from "../../../../assets/Flag.svg";
import S3 from "react-aws-s3";
import { Buffer } from "buffer";
import UploadModal from "../../../../components/UploadModal";
window.Buffer = Buffer;

const modelSchema = Yup.object().shape({
  mobile: Yup.string().required("Phone number is required"),
  name: Yup.string().required("Name is required"),
});

const CompleteRegistration = () => {
  const history = useHistory();
  const { setMobile, mobile, setLocationFilter } = useContext(variableContext);

  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [openError, setOpenError] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);

  const [file, setFile] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [registrationDone, setRegistrationDone] = useState(false);
  const [currentLocation, setCurrentLocation] = useState("");
  const [value, setValue] = useState("");
  const fileInputRef = useRef(null);

  const {
    mutateAsync: register,
    isSuccess,
    isError,
    error,
  } = useAuthQuery.Registration();

  const envConfig = process.env;

  const config = {
    bucketName: envConfig.REACT_APP_S3_BUCKET,
    region: envConfig.REACT_APP_S3_REGION,
    dirName: "master-click",
    accessKeyId: envConfig.REACT_APP_S3_ACCESS_KEY_ID,
    secretAccessKey: envConfig.REACT_APP_S3_SECRET_ACCESS_KEY,
  };
  const ReactS3Client = new S3(config);

  useEffect(() => {
    if (mobile) {
      setPhoneNumber(mobile);
    }
  }, [mobile]);

  const handleClose = () => {
    setName("");
    setPhoneNumber("");
    setOpenError(false);
  };

  const initialValues = {
    name,
    mobile: phoneNumber,
  };

  const Api_Key = "AIzaSyDMC5uUfcSScgVY9AGqsGQwYm8P6_LmyYg";

  const handleLocation = (place) => {
    let lat = place.geometry.location.lat();
    let long = place.geometry.location.lng();
    setLocationFilter("latitude", lat);
    setLocationFilter("longitude", long);
    setLocationFilter("locationName", place.name);
    setCurrentLocation(place.name);
  };

  const handleImage = async (e) => {
    if (!e.target.files.length) return;
    const selectedFile = e.target.files[0];
    setImagePreview(URL.createObjectURL(selectedFile));
    try {
      setUploadModal(true);
      const data = await ReactS3Client.uploadFile(selectedFile);
      setFile(data.location);
      handleCloseUpload();
    } catch (error) {
      handleCloseUpload();
    }
  };

  const handleCloseUpload = () => {
    setUploadModal(false);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: modelSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setStatus, setSubmitting, resetForm }) => {
      setPhoneNumber(values.mobile);
      try {
        await register({
          name: values.name,
          mobile: values.mobile,
          image: file,
          location: currentLocation,
          mobile_number: values.mobile,
          whatsapp_number: values.mobile,
        });
      } catch (error) {
        setStatus("Something went wrong");
        setSubmitting(false);
        resetForm();
      }
    },
  });

  // Detect unsaved changes: form touched or image selected but not yet submitted
  const hasUnsavedChanges = formik.dirty || !!imagePreview;

  const handleBackHome = () => {
    if (hasUnsavedChanges) {
      const confirmed = window.confirm(
        "Save ചെയ്യാത്ത മാറ്റങ്ങൾ നഷ്ടപ്പെടും. തുടരണോ?"
      );
      if (!confirmed) return;
    }
    history.push("/");
  };

  useEffect(() => {
    if (isSuccess) {
      setMobile(phoneNumber);
      setRegistrationDone(true);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      setMessage(error?.response?.data?.message);
      setOpenError(true);
    }
  }, [isError]);

  return (
    <>
      {openError ? (
        <RegistrationErrorModal
          Toggle={openError}
          handleClose={handleClose}
          message={message}
          title="Error"
        />
      ) : null}

      <div
        className="completeRegistration-bg-screen"
        style={{ backgroundColor: theme.palette.primary.main }}
      >
        <div className="">
          <ArrowBackIcon
            onClick={() => history.push("/")}
            style={{
              color: "#fff",
              position: "relative",
              top: "2rem",
              left: "1rem",
            }}
          />
        </div>

        <form onSubmit={formik.handleSubmit} noValidate>
          <div className="completeRegistration-bottomBox">

            {/* ── Success state ── */}
            {registrationDone ? (
              <div className="cr-success-panel">
                <CheckCircleIcon className="cr-success-icon" />
                <Typography className="cr-success-title">
                  രജിസ്ട്രേഷൻ വിജയകരം!
                </Typography>
                <Typography className="cr-success-msg">
                  നിങ്ങളുടെ രജിസ്ട്രേഷൻ വിജയകരമായി സ്വീകരിച്ചിരിക്കുന്നു.
                  24 മണിക്കൂറിനുള്ളിൽ പരിശോധന പൂർത്തിയാക്കി അംഗീകാരം നൽകുന്നതാണ്.
                </Typography>
                <Button
                  variant="contained"
                  className="cr-home-btn"
                  startIcon={<HomeIcon />}
                  onClick={() => {
                    formik.resetForm();
                    setFile("");
                    setImagePreview("");
                    setRegistrationDone(false);
                    history.push("/");
                  }}
                >
                  ഹോം പേജ്
                </Button>
              </div>
            ) : (
              <>
                <div className="completeRegistration-title">
                  <Typography style={{ fontSize: "31px", fontWeight: "600" }}>
                    Complete Registration
                  </Typography>
                  <Typography style={{ fontSize: "16px", fontWeight: "400" }}>
                    Complete your sign-up and start discovering the best local
                    businesses near you.
                  </Typography>
                </div>

                <div className="completeRegistration-form-body">
                  <Typography className="title">Name</Typography>
                  <input
                    placeholder="Name"
                    className="reg-inp"
                    {...formik.getFieldProps("name")}
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="error-message">{formik.errors.name}</div>
                  ) : ""}

                  <Typography className="title">Phone Number</Typography>
                  <div className="dropdown-mob-num">
                    <FormControl>
                      <Select
                        value={value}
                        displayEmpty
                        sx={{
                          height: "51px",
                          borderTopLeftRadius: "70px",
                          borderBottomLeftRadius: "70px",
                          "& .MuiSelect-select": { marginTop: "4px" },
                          "& .MuiSelect-icon.Mui-disabled": { color: "black !important" },
                        }}
                        disabled
                      >
                        <MenuItem value="" sx={{ marginTop: "4px" }}>
                          <img src={Flag} alt="IN" />
                        </MenuItem>
                      </Select>
                    </FormControl>
                    <input className="inp-number" {...formik.getFieldProps("mobile")} />
                  </div>
                  {formik.touched.mobile && formik.errors.mobile ? (
                    <div className="error-message">{formik.errors.mobile}</div>
                  ) : ""}
                </div>

                <Box className="completeRegistration-form-body">
                  <Grid container columnSpacing={2}>
                    <Grid item xs={12}>
                      <Typography className="title">Current Location</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <ReactGoogleAutocomplete
                        apiKey={Api_Key}
                        options={{
                          types: ["neighborhood", "locality", "sublocality", "postal_code", "point_of_interest"],
                          componentRestrictions: { country: "in" },
                          fields: ["address_components", "geometry", "icon", "name", "place_id", "formatted_address"],
                        }}
                        name="location"
                        onPlaceSelected={(place) => handleLocation(place)}
                        style={{
                          width: "100%",
                          height: "48px",
                          border: "1px solid white",
                          borderRadius: "50px",
                          paddingLeft: "15px",
                          boxShadow: "-2px 0px 5px rgba(22, 107, 142, 0.25)",
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* ── Shop Image Upload Card ── */}
                <div className="completeRegistration-form-body" style={{ marginTop: 10 }}>
                  <Typography className="title">Shop Image</Typography>

                  {/* Hidden file input */}
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleImage}
                  />

                  {/* Tappable upload card */}
                  <div
                    className={`cr-upload-card ${imagePreview ? "cr-upload-card--filled" : ""}`}
                    onClick={() => fileInputRef.current?.click()}
                  >
                    {imagePreview ? (
                      <img src={imagePreview} alt="preview" className="cr-upload-preview" />
                    ) : (
                      <>
                        <AddPhotoAlternateOutlinedIcon className="cr-upload-icon" />
                        <Typography className="cr-upload-hint-ml">
                          നിങ്ങളുടെ സ്ഥാപനത്തിന്റെ വ്യക്തമായ തിരിച്ചറിയൽ നൽകുന്ന,
                          ഉയർന്ന ഗുണമേന്മയുള്ളതും ഫയൽ വലുപ്പം ഒപ്റ്റിമൈസ് ചെയ്തതുമായ
                          ഒരു ചിത്രം അല്ലെങ്കിൽ വിസിറ്റിംഗ് കാർഡ് അപ്ലോഡ് ചെയ്യുക.
                          വ്യക്തവും ആകർഷകവുമായ ചിത്രങ്ങൾ നിങ്ങളുടെ പ്രൊഫൈൽ വേഗത്തിൽ
                          ലോഡ് ചെയ്യാനും, ഉപഭോക്താക്കളുടെ വിശ്വാസം വർദ്ധിപ്പിക്കാനും,
                          കൂടുതൽ ആളുകളിലേക്ക് നിങ്ങളുടെ സ്ഥാപനം എത്തിച്ചേരാനും
                          സഹായിക്കും.
                        </Typography>
                        <Typography className="cr-upload-tap">ഇവിടെ ടാപ്പ് ചെയ്യുക</Typography>
                      </>
                    )}
                  </div>

                  {/* Secondary choose / change button */}
                  <Button
                    variant="outlined"
                    size="small"
                    className="cr-choose-btn"
                    onClick={() => fileInputRef.current?.click()}
                  >
                    {imagePreview ? "Change Image" : "Choose File"}
                  </Button>
                </div>

                {/* ── Action buttons ── */}
                <div className="completeRegistration-btn-body2">
                  <Button
                    style={{ backgroundColor: theme.palette.secondary.main }}
                    className="completeRegistration-btn2"
                    variant="contained"
                    type="submit"
                  >
                    Complete Registration
                  </Button>
                  <Button
                    variant="contained"
                    className="cr-back-home-btn"
                    startIcon={<HomeIcon />}
                    onClick={handleBackHome}
                    type="button"
                  >
                    Back Home
                  </Button>
                </div>
              </>
            )}

          </div>
        </form>

        {uploadModal ? (
          <UploadModal open={uploadModal} handleClose={handleCloseUpload} />
        ) : null}
      </div>
    </>
  );
};

export default CompleteRegistration;
